import { z } from "zod"

export const isLearnWorldsRoute = (pathname: string): boolean =>
  /^\/sso\/learnworlds(?:\/|$)/.test(pathname)

const requestSchema = z.object({
  organizationId: z.string().regex(/^org_[a-zA-Z0-9]+$/),
  action: z.enum(["login", "signup", "passwordreset"]),
  redirectUrl: z.string().min(1).max(2048).optional(),
  entry: z.enum(["school", "grow"]),
})

export type LearnWorldsRequest = z.infer<typeof requestSchema>

export function parseLearnWorldsLocation(
  pathname: string,
  search: string,
): LearnWorldsRequest | null {
  const match = /^\/sso\/learnworlds\/(org_[a-zA-Z0-9]+)$/.exec(pathname)
  const query = new URLSearchParams(search)
  if (
    !match ||
    [...query.keys()].some(
      (key) => !["action", "redirectUrl", "entry"].includes(key) || query.getAll(key).length !== 1,
    )
  )
    return null
  const parsed = requestSchema.safeParse({
    organizationId: match[1],
    action: query.get("action") ?? "login",
    redirectUrl: query.get("redirectUrl") ?? undefined,
    entry: query.get("entry") ?? "school",
  })
  return parsed.success ? parsed.data : null
}

export function growLandingPath(organizationId: string): string {
  return `/sso/learnworlds/${encodeURIComponent(organizationId)}?action=login&entry=grow`
}
